import {
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT,
} from '../../Entity'

export const REQUEST_PROFILE_HEADER_CONTENT_DESCRIPTION_CLAMPING_LINES_COUNT = 3

export const REQUEST_PROFILE_HEADER_CONTENT_DESCRIPTION_ACTIONS_KEY_TRANSLATE =
  'translate'

export const REQUEST_PROFILE_HEADER_CONTENT_DESCRIPTION_ACTION_QA_NAMES = {
  [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD]:
    'requestProfileHeaderDescriptionAddBtn',
  [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT]:
    'requestProfileHeaderDescriptionEditBtn',
  [REQUEST_PROFILE_HEADER_CONTENT_DESCRIPTION_ACTIONS_KEY_TRANSLATE]:
    'requestProfileHeaderDescriptionTranslateBtn',
}
